export const DEFAULT_QB_FILTER_KEY = 'default_qb_filters';

export enum QBOperator {
  Eq = '__eq',
  Neq = '__neq',
  Gt = '__gt',
  Gte = '__gte',
  Lt = '__lt',
  Lte = '__lte',
  In = '__in',
  NotIn = '__not_in',
  IsNull = '__isnull',
  ILike = '__ilike',
  Like = '__like',
  IsNotNull = '__isnotnull',
  Contains = '__contains',
  Overlap = '__overlap',
  ContainedBy = '__contained_by',
  IStartsWith = '__istartswith'
}

export const QB_OPERATOR_LABELS: Record<QBOperator, string> = {
  [QBOperator.Eq]: '=',
  [QBOperator.Neq]: '!=',
  [QBOperator.Gt]: '>',
  [QBOperator.Gte]: '>=',
  [QBOperator.Lt]: '<',
  [QBOperator.Lte]: '<=',
  [QBOperator.In]: 'in',
  [QBOperator.NotIn]: 'not in',
  [QBOperator.IsNull]: 'is empty',
  [QBOperator.IsNotNull]: 'is not empty',
  [QBOperator.ILike]: 'contains',
  [QBOperator.Like]: 'contains (case-sensitive)',
  [QBOperator.Contains]: 'contain',
  [QBOperator.Overlap]: 'overlap',
  [QBOperator.ContainedBy]: 'contained by',
  [QBOperator.IStartsWith]: 'starts with'
};
